import { createTheme, responsiveFontSizes } from '@mui/material/styles'

// Custom variables definition
declare module '@mui/material/styles' {
    interface Theme {
        drawer: {
            width: number | string;
        };
    }
    interface ThemeOptions {
        drawer?: {
            width: number | string;
        };
    }
}

export const theme = responsiveFontSizes(createTheme({
    typography: {
        fontFamily: [
            'Poppins',
            'sans-serif'
        ].join(',')
    },
    palette: {
        primary: {
            main: '#004bb1'
        },
        secondary: {
            main: '#04B3FF'
        }
    },
    drawer: {
        width: 300
    }
}))
